import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import TaxData from "../../data/TaxData";
import {showToast} from "../../actions/ToastAction";
import {taxDialog} from "../../actions/TaxDialogAction";
import {selectTax} from "../../actions/TaxSelectActions";

class TaxDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            tax: {
                name: "",
                percentage: 0,
                id: null
            },
            name_error: false,
            percentage_error: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePercentageChange = this.handlePercentageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.tax_dialog){
            this.setState({tax:nextProps.tax_dialog.tax});
        }
    }

    handleNameChange = (event) => {
        let name = update(this.state, {
            tax: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true});
        } else {
            this.setState({name_error: false});
        }
    };

    handlePercentageChange = (event) => {
        let percentage = update(this.state, {
            tax: {
                percentage: {
                    $set: event.target.value
                }
            }
        });
        this.setState(percentage);
        if (event.target.value.trim() === '' || event.target.value < 0) {
            this.setState({percentage_error: true});
        } else {
            this.setState({percentage_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.tax.name === "") {
            this.setState({name_error: true});
        } else if (this.state.tax.percentage === "" || this.state.tax.percentage < 0) {
            this.setState({percentage_error: true});
        } else {
            this.setState({loading: true});
            if (this.state.tax.id) {
                TaxData.update(this.state.tax, (res) => {
                    if (res !== null) {
                        this.dispatchData(res, 'Impuesto Actualizado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                    }
                    this.setState({loading: false});
                });
            } else {
                TaxData.add(this.state.tax, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Impuesto Agregado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({open: false, loading: false});
                });
            }
        }
    };

    handleClose = () => {
        this.setState({name_error:false, percentage_error:false, loading:false});
        this.props.taxDialog({open: false, tax:{id:null, name:'', percentage:0}});
    };

    dispatchData = (tax, message) => {
        this.props.selectTax(tax);
        this.props.taxDialog({open: false, tax:{id:null, name:'', percentage:0}});
        this.props.showToast({message: message, type: 'success'});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.props.tax_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.tax_dialog.tax.id ? 'Actualizar Impuesto':'Nuevo Impuesto'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input label='Impuesto' placeholder='Impuesto'
                                                        value={this.state.tax.name} onChange={this.handleNameChange}
                                                        error={this.state.name_error}/>
                                            <Form.Input label='Porcentaje' min={0} max={100} type='number'
                                                        placeholder='Porcentaje' value={this.state.tax.percentage}
                                                        onChange={this.handlePercentageChange}
                                                        error={this.state.percentage_error}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' disabled={this.state.loading}
                                loading={this.state.loading} labelPosition='left' onClick={this.handleSubmit}
                                content={this.props.tax_dialog.tax.id ? 'Actualizar':'Guardar'}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        tax_dialog: state.get('tax_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        taxDialog(data) {
            dispatch(taxDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectTax(data){
            dispatch(selectTax(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TaxDialog);


// WEBPACK FOOTER //
// ./src/components/settings/TaxDialog.js